import React from 'react';
import Button from './form/Button';
import { has } from 'underscore';

export default function CardToolbar({ fnViewAllQuestion, isViewAllQuestions, hasSections }) {
  const isChecked = hasSections ? true : isViewAllQuestions;
  const isDisabled = hasSections;

  return (
    <div className="card-toolbar singlePgview">
      <ul className="nav nav-pills nav-pills-sm">
        <li className="nav-item AllQcheckBox">
          {!hasSections ? <div
            className="form-check"
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={fnViewAllQuestion} 
          >
            <input
              type="checkbox"
              id="view"
              name="view"
              value="pprView"
              checked={isChecked}
              disabled={isDisabled}
              readOnly
              className={`form-check-input btn btn-${isChecked ? 'primary' : 'view-questions'} btn-sm font-weight-bolder`}
            />
            <label className="view" htmlFor="view">Single page view</label>
          </div> : null}
        </li>
      </ul>
    </div>
  );
}
